import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FullPagePreviewModal from 'web-interactives-components/full-preview/FullPagePreviewModal';
import { CONTAINER_TYPES_WITH_PREVIEW_ON_PAGE } from 'web-interactives-data/constants/ContainerConstants';
import { MODAL_TYPES } from 'web-interactives-dashboard-ui/constants/ModalConstants';
import withModalProps from 'web-interactives-dashboard-ui/hoc/withModalProps';
import { getPreviewDomain } from 'web-interactives-dashboard-ui/selectors/preview';
import { getCtaPreviewUrl } from 'web-interactives-dashboard-ui/utils/urls';
import { fetchPreviewPages } from 'web-interactives-dashboard-ui/actions/PreviewActions';
import { getPreviewPagesOptions } from 'web-interactives-dashboard-ui/selectors/preview';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewModal = ({
  interactiveId,
  containerType,
  onClose
}) => {
  const dispatch = useDispatch();
  const previewDomain = useSelector(getPreviewDomain);
  const previewPages = useSelector(getPreviewPagesOptions);
  const showPreviewPages = CONTAINER_TYPES_WITH_PREVIEW_ON_PAGE.includes(containerType);
  useEffect(() => {
    if (showPreviewPages) {
      dispatch(fetchPreviewPages(interactiveId));
    }
  }, [dispatch, showPreviewPages, interactiveId]);
  return /*#__PURE__*/_jsx(FullPagePreviewModal, {
    basePreviewUrl: getCtaPreviewUrl(previewDomain, interactiveId),
    onClose: onClose,
    previewPageOptions: previewPages,
    showPreviewPages: showPreviewPages
  });
};
export default withModalProps(PreviewModal, MODAL_TYPES.PREVIEW_CTA);